import { memo } from 'react';
import hexagon from '../../assets/animations/hexagon.json';
import LottieAnimation from './LottieAnimation';

function TestnetBackground() {
  return <LottieAnimation animationData={hexagon} />;
}

export default memo(TestnetBackground);
